import { Component } from '@angular/core';
import { MenuComponent } from "../menu/menu.component";
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-header',
    imports: [MenuComponent, CommonModule, RouterModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.css'
})
export class HeaderComponent {

  isCollapsed : boolean = false;

  constructor(public router: Router ) {
  }

  ngOnInit() {
  }

  toggleCollapseMenu() {
    this.isCollapsed = !this.isCollapsed;
  }
}
